<template>
  <div class="col-md-8 m-auto p-2">
    <div class="col-md=12  justify-content-center chart-container">
        <canvas :id="id" @dblclick="resetZoomBtn(myChart)" ></canvas>
    </div>
  </div>
</template>

<!-- ######################################################################################################## -->

<script setup>
import { onMounted, defineProps } from 'vue'
import {Chart} from 'chart.js/auto'
// import { newDate, newDateString, rand, transparentize, CHART_COLORS } from '../js/tmlf.js'
import { transparentize } from '../js/tmlf.js'
import 'chartjs-adapter-moment'
import zoomPlugin from 'chartjs-plugin-zoom';

const props = defineProps({
    id: String,
    label: String,
    label2: String,
    data0Color: String,
    data2Color: String,
    data: Array,
    data2: Array,
    fill: Boolean,
    min: Number,
    max: Number,
    showLine1: Boolean,
    showLine2: Boolean,
    hideToolTip2: Boolean,
 })

// data = [{
//         x: '2021-11-06 23:39:30',
//         y: 50
//     }, {
//         x: '2021-11-07 01:00:28',
//         y: 60
//     }, {
//         x: '2021-11-07 09:00:28',
//         y: 20
//     }, {
//         x: '2023-01-07 11:25:28.852',
//         y: 10
//     }]

var myChart 
let pointRadius1 = 0
props.showLine1 ? pointRadius1 = 0 : pointRadius1 = 3
let pointRadius2 = 0
props.showLine2 ? pointRadius2 = 0 : pointRadius2 = 3


const chartData = {
    type: 'line',
    data: {
        datasets: [
        {
           label: props.label,
           data: props.data,
           fill: props.fill,
           hoverBorderColor: '#fff',
           showLine: props.showLine1,
           radius: pointRadius1,
        },
        ],
    },
    options: {
        locale: 'de-DE',
        scales: {
            x: {
                type: 'time',
                time: {
                    displayFormats: {
                        quarter: 'MMM YYYY',
                        hour: 'HH',
                        minute: 'HH:mm',
                    },
                    tooltipFormat: 'HH:mm - DD.MM.YYYY',
                },
                ticks: {
                    color: '#ddd',
                },
                grid:{
                    color: '#333333',
                },
            },
            y: {
                min: props.min,
                max: props.max,
              title: {
                  display: false,
                  text: '',
                  color: '#ddd',
                  align: 'end',
              },
              ticks: {
                    color: '#ddd',
                },
                grid:{
                    color: '#333333',
                },
            },
        },
        plugins: {
            zoom: {
                limits: {
                    x: {min: 'original', max: 'original'},
                },
                zoom: {
                wheel: {
                    enabled: true,
                },
                pinch: {
                    enabled: true,
                },
                drag: {
                    enabled: true,
                },
                mode: 'x',
                // scaleMode: 'y',
                },
            },
            legend: {
                display: true,
                labels: {
                    color: '#ddd',
                },            
            },
            tooltip: {
                backgroundColor: '#000',
                enabled: true,
            },
        },
        elements: {
            point: {
                pointStyle: 'circle',
                borderColor: props.data0Color,
                backgroundColor: transparentize(props.data0Color, 0.5),
                // radius: pointRadius,
                hitRadius: 16,
                hoverRadius: 16,
            },
            line: {
                borderColor: props.data0Color,
                backgroundColor: transparentize(props.data0Color, 0.5),
                borderWidth: 2,
            },
        },
    },
};

const resetZoomBtn = (chart) => {  
    chart.resetZoom()
};

if (props.data2) {
    const dataset2 = {
        label: props.label2,
        backgroundColor: transparentize(props.data2Color, 0.5),
        borderColor: props.data2Color,
        data: props.data2,
        borderWidth: 2,
        fill: props.fill,
        hoverBorderColor: '#fff',
        showLine: props.showLine2,
        radius: pointRadius2,       
    }

    chartData.data.datasets.push(dataset2)

    if (props.hideToolTip2) {chartData.options.plugins.tooltip.filter = function(tooltipItem) {
            return tooltipItem.datasetIndex === 0;
        }
    }
    
}


onMounted(() => {
    // console.log(props)
        Chart.register(zoomPlugin);
        const ctx = document.getElementById(props.id);
        myChart = new Chart(ctx, chartData);
})

</script>

<!-- ######################################################################################################## -->

<style>

canvas {
  border: 1px dotted gray;
}

.chart-container {
  position: relative;
  /* margin: auto; */
  /* height: 60vh; */
  /* height: 500px; */
  /* width: 60vw; */
  /* width: 500px; */
}

</style>
